import { combineReducers }  from 'redux-immutablejs';
import viewElements         from './view-elements';
import viewData             from './view-data';

export default combineReducers({
    viewElements,
    viewData
})